import styled from "styled-components";
import { breakpoints } from "../../../../constants/media";

const Container = styled.div`
  width: 100%;
  margin: 35px 0px 0px 0px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  // Acordion
  .accordion {
    width: 100%;
    border: 0px;
    max-width: 1300px;
    background-color: var(--white);
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    margin: 0 auto;
    border-radius: 12px 12px 12px 12px !important;
  }

  // Heading
  .heading {
    border: 0px;
  }

  // Button
  .button {
    display: flex;
    min-height: 56px;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    padding: 17px 15px 17px 15px;
    pointer-events: none;
  }

  // Logo and Plan Seguro
  .logoPlan {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    max-width: 111px;
    border-right: 1px solid var(--lightgray2);
    padding: 0px 18px 0px 0px;
  }

  .logoPlan img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .logoPlan p {
    font-family: Raleway;
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    text-align: center;
    color: var(--orange);
    margin: 7px 0px 0px 0px;
  }

  // Checks Plan
  .checksPlan {
    width: calc(100% - 130px);
    display: flex;
    justify-content: space-between;
    margin: 0px 0px 0px 0px;
    align-content: center;
    align-items: center;
  }

  .checksPlan div {
    max-width: 135px;
    min-width: 135px;
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
  }

  .checksPlan div span {
    width: 100%;
    text-align: center;
    color: var(--green);
    font-size: 0.9em;
    margin: 0px 0px 0px 0px;
  }

  .checksPlan div p {
    width: 100%;
    text-align: center;
    font-size: 13px;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    margin: 10px 0px 0px 0px;
  }

  #checkNo {
    color: red !important;
  }

  // Informacion de precios Container
  .priceData {
    max-width: 135px;
    min-width: 135px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }

  // Informacion de precios
  .priceData div {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  // Informacion de precios text
  .priceData div p {
    width: auto;
    margin: 0px 3px 0px 3px;
    font-family: Raleway;
    font-style: normal;
  }

  // Cuotas y precio anterior
  .cuotasContainer {
    font-weight: normal;
    font-size: 13px;
    text-align: center;
    color: var(--lightgray);

    #cuotas {
      color: ${(props) =>
        props.precioAnterior == ""
          ? "var(--orange)"
          : "var(--lightgray)"} !important;
      font-weight: ${(props) =>
        props.precio == "" ? "bold" : "normal"} !important;
    }

    #precioAnterior {
      text-decoration: line-through;
      font-weight: bold;
    }
  }

  // Precio y oferta
  .ofertaContainer {
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    color: var(--orange);
    margin: 6px 0px 6px 0px;
  }

  // Contratando
  .contratandoContainer {
    font-weight: 700;
    font-size: 11px;
    text-align: center;
    color: var(--orange);
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Checks Plan
    .checksPlan div {
      max-width: 121px;
      min-width: 121px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    width: auto;

    // Checks Plan
    .checksPlan {
      display: none;
    }

    // Informacion de precios Container
    .priceData {
      margin: 0px 0px 0px 15px;
    }
  }
`;

export default Container;
